import {
    Form,
    Input,
    Modal
} from "antd";
import './styles.scss';
const { TextArea } = Input;

type Props = {
    open: boolean;
    type: number
    onCancel: () => void;
};



export default function ModalNotificationEmailTemplate({
    open,
    type,
    onCancel,
}: Props) {
    const data = {
        title: "Mẫu 2: Thông báo tài khoản đã được kích hoạt",
        subject: "CRM THACO AUTO | Kích hoạt tài khoản",
        username: "[email]",
        password: "Pass Email THACO (cố định)",
        loginLink: "[Link đăng nhập]",
        supportEmail: "crm.auto@thaco.com.vn",
    }
    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            width={900}
            // title="Tạo mới mẫu email thông báo"
            destroyOnClose
        >

            {/* <Row gutter={12} className="pt-4">
                    <Col span={18} >
                        <Form.Item
                            name="title"
                            rules={[{ required: true, message: "Nhập tiêu đề email" }]}
                        >
                            <Input placeholder="Nhập tiêu đề mẫu email" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item name="params">
                            <Select
                                placeholder="Tham số"
                                options={[
                                    { label: "Tên khách hàng", value: "customer_name" },
                                    { label: "Biển số xe", value: "license_plate" }
                                ]}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <div className="">

                    <Ckeditor />
                </div>
                <Divider />

                <h4>Cài đặt kích hoạt</h4>

                <Form.Item
                    label="Sự kiện kích hoạt"
                    name="trigger"
                    rules={[{ required: true, message: "Chọn sự kiện" }]}
                >
                    <Select
                        placeholder="Chọn sự kiện"
                        options={[
                            {
                                label: "Nhóm khách hàng chia sẻ mới",
                                value: "new_customer_group"
                            },
                            {
                                label: "Tạo lịch hẹn",
                                value: "appointment_created"
                            }
                        ]}
                    />
                </Form.Item>

                <div style={{ textAlign: "right" }}>
                    <Space>
                        <Button onClick={onCancel}>Hủy</Button>
                        <Button type="primary" htmlType="submit">
                            Lưu
                        </Button>
                    </Space>
                </div> */}
            {type === 1 ?
                <div className="">
                    <div className="custom-page-css flex flex-col gap-4">
                        <h1 className="email-title">
                            Mẫu 1: Yêu cầu phê duyệt tài khoản
                        </h1>

                        <p className="email-description">
                            <strong>Mô tả:</strong>{" "}
                            Hệ thống tự động gửi email{" "}
                            <span className="underline">thông báo cho admin</span>{" "}
                            khi có user chưa được cấp quyền truy cập
                        </p>

                        <p className="section-title">Nội dung:</p>

                        <div className="email-content">
                            <p className="subject-line">
                                <strong>Subject:</strong>{" "}
                                CRM THACO AUTO | Yêu cầu duyệt tài khoản
                            </p>

                            <p className="body-line first-body-line">
                                Hệ thống ghi nhận yêu cầu đăng ký tài khoản mới cần được xem xét và phê duyệt:
                            </p>

                            <p className="body-line">
                                <strong>Email:</strong> [Email người dùng]
                            </p>

                            <p className="body-line approve-line">
                                Vui lòng truy cập hệ thống để kiểm tra thông tin và thực hiện phê duyệt tại đây:{" "}
                                <strong>[link phê duyệt]</strong>
                            </p>
                        </div>
                    </div>
                </div>
                :
                <div className="">
                    <div className="custom-page-css flex flex-col gap-4">
                        <h1 className="email-activated-title">
                            {data.title}
                        </h1>

                        <p className="email-activated-description">
                            <strong>Mô tả:</strong>{" "}
                            Hệ thống tự động gửi email{" "}
                            <span className="underline">thông báo</span>{" "}
                            cho user sau khi tài khoản được duyệt và phân quyền thành công
                        </p>

                        <p className="section-title">Nội dung:</p>

                        <div className="email-activated-content">
                            <p className="subject-line">
                                <strong>Subject:</strong>{" "}
                                {data.subject}
                            </p>

                            <p className="body-line intro-line">
                                Tài khoản đã được phê duyệt và kích hoạt thành công. Vui lòng truy cập theo thông tin bên dưới:
                            </p>

                            <p className="body-line">
                                <strong>Tên đăng nhập:</strong> {data.username}
                            </p>

                            <p className="body-line">
                                <strong>Mật khẩu:</strong> {data.password}
                            </p>

                            <p className="body-line">
                                <strong>Liên kết truy cập:</strong> {data.loginLink}
                            </p>

                            <p className="body-line support-line">
                                Mọi thắc mắc vui lòng liên hệ bộ phận CRM để được hỗ trợ -{" "}
                                <a href={`mailto:${data.supportEmail}`} className="support-email">
                                    {data.supportEmail}
                                </a>
                            </p>

                            <p className="body-line">
                                Trân trọng,
                            </p>
                        </div>
                    </div>
                </div>

            }
        </Modal>
    );
}